export default __webpack_public_path__ + "static/media/badEmoji.a88ff7c6.svg";